import React from 'react'
import AboutCard from './AboutCard';
import { fontStyle } from '../../Styles';

function Home() {
	return (
		<div style={{ ...fontStyle }}>
			<AboutCard />
		</div>
	);
}

export class HomeTitle extends React.Component{
	render(){
		return(
			<p style={{position: 'fixed', left: 0}}>Home</p>
		);
	}
}

export default Home
